import { createContext, type PropsWithChildren, useContext } from "react"

const PollingPauseContext = createContext(false)

type Props = Readonly<PropsWithChildren<{ paused: boolean }>>

export function PollingPauseProvider({ paused, children }: Props) {
    return <PollingPauseContext.Provider value={paused}>{children}</PollingPauseContext.Provider>
}

export function useIsPollingPaused() {
    return useContext(PollingPauseContext)
}
